export default "__VITE_ASSET__nuWu6PMr__"